import useQuestions from "../../hooks/useAuditQuestions";

const useFormPage2 = ({ dispatch, ACTIONS }) => {
  const { splicerQuestions } = useQuestions();

  /*
    Switch on question GUIDs from COLLECTOR_AUDIT_QUESTIONS to call
    the appropriate state update action.
  */
  const questionInputHandler = (identifier, input) => {
    switch (identifier) {
      case splicerQuestions.fiberSplicing:
        dispatch({
          type: ACTIONS.SET_FIBER_SPLICING,
          value: input,
        });
        dispatch({ type: ACTIONS.SET_FORM_VALID });
        break;
      case splicerQuestions.housekeeping:
        dispatch({
          type: ACTIONS.SET_HOUSEKEEPING,
          value: input,
        });
        dispatch({ type: ACTIONS.SET_FORM_VALID });
        break;
      case splicerQuestions.requiredPPE:
        dispatch({
          type: ACTIONS.SET_REQUIRED_PPE,
          value: input,
        });
        dispatch({ type: ACTIONS.SET_FORM_VALID });
        break;
      case splicerQuestions.requiredWAP:
        dispatch({
          type: ACTIONS.SET_REQUIRED_WAP,
          value: input,
        });
        dispatch({ type: ACTIONS.SET_FORM_VALID });
        break;
      default:
        break;
    }
  };

  return {
    questionInputHandler,
  };
};

export default useFormPage2;
